import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_PARTNER_BRANCH } from "helpers/api_endpoints";

const RemovePartnerBranch = () => {
    const params = useParams();
    const { id } = params;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_PARTNER_BRANCH, { id })
        .then(response => {
            navigate(`/partnersbranch`, { 
                state: { successMsg: 'Partner Branch Deleted Successfully' } 
            });
        })
        .catch(error => {
            console.error("Error deleting partner branch:", error);
            navigate(`/partnersbranch`, { 
                state: { errorMsg: error?.response?.data?.message || 'Failed to delete partner branch' } 
            });
        });
    }, [id, navigate]);

    return <React.Fragment>Removing partner branch...</React.Fragment>;
};

export default withRouter(RemovePartnerBranch);